import React from "react";

const SuccessDeclineModal = ({
  isSuccessDeclineModalOpen,
  closeSuccessDeclineModal,
}) => {
  return (
    <>
      <div
        className={`${
          isSuccessDeclineModalOpen ? "flex" : "hidden"
        } fixed inset-0 z-20 flex items-center justify-center overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative bg-white shadow max-w-[38%] h-[38vh] mx-auto p-6 rounded-sm text-center">
          {/* Title */}
          <h2 className="text-black text-lg font-semibold mt-4">SUCCESS!</h2>

          {/* Success Icon */}
          <div className="w-20 h-20 bg-[#8ED6A8] rounded-full flex items-center justify-center mx-auto">
            <img src="/green-tick.png" alt="Success" className="w-12 h-12" />
          </div>

          {/* Success Message */}
          <p className="text-black text-sm mt-2">
            Loan Successfully Declined. The loan application has been declined
            and will not proceed to the next stage.
          </p>

          {/* Close Button */}
          <button
            onClick={closeSuccessDeclineModal}
            className="border border-[#005C53] text-[#005C53] w-[251px] h-12 rounded-lg mt-[54px]"
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default SuccessDeclineModal;
